import service from "./index";

/**
 * 收藏夹列表
 */
export function collectionslist (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/collectionslist",
    data: data
  })
}

/**
 * 创建收藏夹
 */
export function createcollections (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/createcollections",
    data: data
  })
}

/**
 * 删除收藏夹
 */
export function deletecollections (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/deletecollections",
    data: data
  })
}

/**
 * 修改收藏夹
 */
export function editcollections (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/editcollections",
    data: data
  })
}

/**
 * 收藏夹内容
 */
export function collectionsinfo (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/collectionsinfo",
    data: data
  })
}

/**
 * 查询用户积分
 */
export function getPoints (data) {
  return service.request({
    method: "post",
    url: "/superiormarket/pygh2/points/points/get",
    data: data
  })
}

/**
 * 用户身份
 */
export function userId (data) {
  return service.request({
    method: "post",
    url: "/ucenter/oauth_group/get",
    data: data
  })
}

/**
 * 用户绑定状态
 */
export function isbindWeixin (data) {
  return service.request({
    method: "post",
    url: "/ucenter/user/refresh",
    data: data
  })
}

/**
 * 用户解绑
 */
export function unBindWchat (data) {
  return service.request({
    method: "post",
    url: "/ucenter/wechat/del",
    data: data
  })
}

/**
 * 小图片
*/
export function adCard (data) {
  return service.request({
    method: "post",
    url: "/paytoschool/small_picture/get",
    data: data
  })
}

/**
 * 草稿箱列表
 */
export function draftlist (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/draftlist",
    data: data
  })
}

/**
 * 审核中列表
 */
export function reviewlist (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/review",
    data: data
  })
}

/**
 * 发布文章列表
 */
export function publishedlist (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/published",
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/perCenter.js